<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Terms</h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a href="/">Home</a>
                                </li>
                                <li class="breadcrumb-item">
                                    <a href="/">Settings</a>
                                </li>
                                <li class="breadcrumb-item active">Terms</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right ml-1" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Add Term</span></button>
                    
                    <button class="btn btn-primary btn-sm pull-right" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
                    
                </div>
            </div>

        </div>

    <div class="content-body">
        <section id="basic-datatable">
            <div class="row">
                <div class="col-12">
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showCreatePanel">
                            <div class="card-header">
                                <h4 class="card-title">Add Term</h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <term-form @completed="getTerms" @cancel="showCreatePanel = !showCreatePanel"></term-form>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div class="card border-bottom" v-if="showFilterPanel">
                            <div class="card-header">
                                <h4 class="card-title">
                                    {{trans('general.filter')}}
                                </h4>
                            </div>
                            <div class="card-content">
                                <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">{{trans('general.keyword')}}</label>
                                            <input class="form-control" name="keyword" v-model="filterTermForm.keyword">
                                        </div>
                                    </div>
                                </div>
                                <button class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
                            </div>
                            </div>
                        </div>
                    </transition>
                    <div class="card">
                        <div class="card-header">
                            <h4 v-if="terms.total" class="card-title">
                                <sort-by :order-by-options="orderByOptions" :sort-by="filterTermForm.sort_by" :order="filterTermForm.order" @updateSortBy="value => {filterTermForm.sort_by = value}"  @updateOrder="value => {filterTermForm.order = value}"></sort-by>
                            </h4>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <div class="table-responsive" v-if="terms.total">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th class="table-option">{{trans('general.action')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="term in terms.data">
                                            <td v-text="term.name"></td>
                                            <td v-html="getStatus(term)"></td>
                                            <td class="table-option">
                                                <div class="btn-group">
                                                    <button class="btn btn-info btn-sm" v-tooltip="'Edit Term'" @click.prevent="editTerm(term)"><i class="feather icon-edit"></i></button>
                                                    <button class="btn btn-danger btn-sm" :key="term.id" v-confirm="{ok: confirmDelete(term)}" v-tooltip="'Delete Term'"><i class="feather icon-trash-2"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <module-info v-if="!terms.total"  module="general" title="module_info_title" description="module_info_description" icon="check-circle">
                                <div slot="btn">
                                    <button class="btn btn-primary btn-md" v-if="!showCreatePanel" @click="showCreatePanel = !showCreatePanel"><i class="feather icon-plus"></i> {{trans('general.add_new')}}</button>
                                </div>
                            </module-info>
                            <pagination-record :page-length.sync="filterTermForm.page_length" :records="terms" @updateRecords="getTerms"></pagination-record>
                             
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   
   </div>
    </div>
</template>

<script>
    import termForm from './form'
    import sortBy from '../../../components/sort-by'

    export default {
        components : { termForm,sortBy },
        data() {
            return {
                terms: {
                    total: 0,
                    data: []
                },
                filterTermForm: {
                    keyword: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                orderByOptions: [
                    {
                        value: 'name',
                        translation: 'Name'
                    }
                ],
                showCreatePanel: false,
                showFilterPanel: false
            };
        },
        mounted(){
            if(!helper.hasPermission('access-settings')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            this.getTerms();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getTerms(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterTermForm);
                axios.get('/api/setting/term?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.terms = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editTerm(term){
                this.$router.push('/setting/term/'+term.id+'/edit');
            },
            confirmDelete(term){
                return dialog => this.deleteTerm(term);
            },
            deleteTerm(term){
                axios.delete('/api/setting/term/'+term.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getTerms();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getStatus(term){
                return term.status ? ('<span class="badge badge-success">'+i18n.general.active+'</span>') : ('<span class="badge badge-warning">'+i18n.general.inactive+'</span>') ;
            }
        },
        watch: {
            filterTermForm: {
                handler(val){
                    setTimeout(() => {
                        this.getTerms();
                    }, 500)
                },
                deep: true
            }
        }
    }
</script>
